<template>
  <swiper :options="Option" class="my-swiper2">
    <swiper-slide v-for="(item, index) in dataInfo" :key="index" style="transform: scale(.9);">
      <div class="rc-main" @click.stop="LinkExInvitation({ companyId: item.compId, exhibitorId: item.id, exhibitionId: item.exhibitionId })" :class="!item.img ? 'rc-main1' : ''">
        <!-- <span class="share" :style="!item.img ? 'background:'+ color : ''">{{item.top ? '助力' : '分享'}}</span> -->
        <div class="rc-bg rc-bg1" :style="{ 'background-image': 'url(' + item.img + ')' }" v-if="item.img" style="filter: blur(2px)"></div>
        <div class="rc-bg1 mc" v-if="item.img"></div>
        <div class="rc-bg" style="background:#fff" v-if="!item.img"></div>
        <div class="rc-content" :class="!item.img ? 'noImg' : ''" :style="!item.img ? boxShadow : ''">
          <div class="rc-top">
            <div class="rc-t-l">
              <img v-if="item.company.logo" :src="item.company.logo" v-load="'oPicXS'" class="s-square" />
              <img
                :class="{ square_logo: configLogoIsSquare }"
                v-else-if="exhibitionInfo && exhibitionInfo.exhibition && exhibitionInfo.exhibition.logo"
                :src="exhibitionInfo.exhibition.logo"
                v-load="'oPicXS'"
                class="s-square"
              />
              <img v-if="!item.company.logo" src="@/assets/img/empty.png" class="s-square" />
            </div>
            <div class="rc-t-r">
              <h2>{{ item.company.nameEn }}</h2>
              <p>{{ item.company.regionEn }}</p>
            </div>
          </div>
          <div class="rc-bot">
            <div class="rc-bot-l">
              <h2>{{ item.categoryEn }}</h2>
              <!-- 统计数据显示 -->
              <div class="item-padd" v-if="item.boothInfo">
                <div class="brand">
                  <span>
                    <i class="icon iconfont icon-dizhi"></i>
                    {{ item.boothInfo }}
                  </span>
                </div>
              </div>
              <!-- <div class="item-padd" v-if="item.boothInfo && item.boothInfo.length ">
                                <div class="brand">
                                    <span class="rc-border">
                                        <i class="icon iconfont icon-dizhi"></i>
                                        <span class="rc-booth">
                                            <span v-for="(booth, i) in item.boothInfo" :key="'booth-' + i">
                                                {{booth.Hall || ''}}{{ (booth.Hall && booth.Code) ? '-' : ''}}{{booth.Code}}
                                                <span v-if="(booth.Hall && booth.Code) && (i !== (item.boothInfo.length - 1))">,</span>
                                            </span>
                                        </span>
                                    </span>
                                </div>
                            </div>  -->
            </div>
            <div class="rc-bot-r" v-if="item.products.length">
              <!-- 产品 -->
              <div class="item-blist">
                <div class="item-blist_one" v-for="(pro, index) in item.products.slice(0, 3)" :key="'pro-' + index" @click.stop="LinkProduct(pro.id)">
                  <div class="item-blist_imgbox">
                    <img :src="JSON.parse(pro.banner)[0]" v-if="JSON.parse(pro.banner)[0]" v-load="'oPicXS'" />
                    <img v-else src="@/assets/img/empty.png" />
                  </div>
                </div>
              </div>
              <!-- /产品 -->
            </div>
          </div>
        </div>
      </div>
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "swiper-banner",
  props: ["data", "color"],
  data() {
    return {
      Option: {
        centeredSlides: true,
        slidesPerView: "auto",
        watchSlidesProgress: true,
        slidesPerView: 1,
        width: 300,
        autoplay: true,
      },
    };
  },
  components: { Swiper, SwiperSlide },
  computed: {
    ...mapGetters({
      exhibitionInfo: "getExhibitionInfo",
      configLogoIsSquare:'getConfigLogoIsSquare'
    }),
    dataInfo() {
      this.data.map((c) => {
        if (c.banner) {
          c.img = c.banner;
        } else {
          if (c.products && c.products.length) {
            let pro = c.products[0];
            let img = JSON.parse(pro.banner)[0];
            c.img = img;
          }
        }
      });
      let arr = [];
      arr = [...this.data];
      return arr;
    },
    clientWidth() {
      return document.body.clientWidth;
    },
    boxShadow() {
      return { "box-shadow": "0px 1px 5px 0px" + this.color };
    },
  },
  created() {
    this.Option.width = this.clientWidth * 0.8;
  },
  methods: {
    ...mapActions({
      LinkExInvitation: "linkTo/LinkExInvitation",
      LinkProduct: "linkTo/LinkProduct",
    }),
  },
};
</script>

<style scoped lang="scss">
.my-swiper2 {
  min-height: 90px;
  min-width: 100%;
  margin: 0.2rem 0 15px;
}
.swiper-container {
  font-size: 0;
}
.swiper-slide-active {
  transform: scale(0.98) !important;
}
.rc-main .share {
  position: absolute;
  right: 0;
  top: 5px;
  width: 34px;
  height: 14px;
  line-height: 14px;
  font-size: 12px;
  text-align: center;
  border-radius: 7px 0px 0px 7px;
  color: #fff;
  z-index: 10;
}
// .rc-main::after{
//     content: "分享";
//     position: absolute;
//     right: 0;
//     top:5px;
//     width: 34px;
//     height: 14px;
//     line-height: 14px;
//     font-size: 12px;
//     text-align: center;
//     // background-color: #a40d6c;
// 	border-radius: 7px 0px 0px 7px;
//     color:#fff;
//     z-index: 10;
// }
.rc-bg1 {
  &.mc {
    background: rgba(0, 0, 0, 0.35);
  }
  border-radius: 5px;
  width: 100%;
  height: 100%;
  z-index: 2;
  position: absolute;
}
.rc-main {
  width: 100%;
  border-radius: 5px;
  position: relative;
  .rc-bg {
    position: absolute;
    z-index: 1;
    background: no-repeat;
    background-size: 100%;
    border-radius: 5px;
    width: 100%;
    height: 100%;
  }
  .rc-content {
    position: relative;
    z-index: 2;
    padding: 5px;
    min-height: 90px;
  }
  .rc-top {
    display: flex;
    .rc-t-l {
      width: 39px;
      height: 39px;
      background-color: #fff;
      border-radius: 5px;
      margin-right: 5px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
      .s-square {
        border-radius: 5px;
      }
    }
    .rc-t-r {
      width: calc(100% - 80px);
      color: #fff;
      height: 39px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      h2,
      p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      h2 {
        font-size: 16px;
        line-height: 1.2;
      }
      p {
        font-size: 12px;
        margin-top: 5px;
      }
    }
  }
  .rc-bot {
    display: flex;
    .rc-bot-l {
      width: 50%;
      color: #fff;
      h2 {
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 4px 0;
        color: #fff;
        font-weight: 400;
        min-height: 0.32rem;
      }
      .item-padd {
        margin-top: 4px;
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #fff;
        flex-wrap: wrap;
        .brand {
          line-height: 1.2;
          margin-right: 8px;
          span {
            color: #fff;
            line-height: 18px;
            display: inline-block;
            display: flex;
            align-items: center;
            .icon-dianzan,
            .icon-guanzhu {
              font-size: 12px;
            }
            .icon-zhiboguankanshu {
              position: relative;
              top: 2px;
            }
            .icon-guanzhu {
              position: relative;
              top: -2px;
            }
          }
          .iconfont {
            font-size: 12px;
            display: inline-block;
            margin-right: 1px;
            color: #fff;
          }
          .icon-dizhi {
            font-size: 18px;
            position: relative;
            top: -2px;
          }
        }
      }
    }
    .rc-bot-r {
      width: 50%;
      padding-left: 4%;
      .item-blist {
        display: flex;
        justify-content: flex-end;
        // .item-blist_one{
        //     width: 30%;
        //     margin-right: 2%;
        //     position: relative;
        //     .item-blist_imgbox{
        //         width: 100%;
        //         position: absolute;
        //         padding-bottom: 100%;
        //         overflow: hidden;
        //         border-radius: 5px;
        //         img{
        //             position: absolute;
        //             width: 100%;
        //             height: 100%;
        //             top: 0;
        //             left: 0
        //         }
        //     }
        // }
        // .item-blist_one:last-child{
        //     margin-right: 0;
        // }
        .item-blist_one {
          width: 40px;
          height: 40px;
          margin-right: 3px;
          position: relative;
          .item-blist_imgbox {
            width: 100%;
            position: absolute;
            padding-bottom: 100%;
            overflow: hidden;
            border-radius: 5px;
            img {
              position: absolute;
              width: 100%;
              height: 100%;
              top: 0;
              left: 0;
            }
          }
        }
        .item-blist_one:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
.rc-main1::after {
  // color:#333;
  background-color: #a40d6c;
}
.noImg {
  box-shadow: 0px 1px 3px 0px rgba(164, 13, 108, 0.3);
  background: #fff;
  border-radius: 5px;
  .rc-t-r {
    h2,
    p {
      color: #333 !important;
    }
  }
  .rc-bot-l {
    h2 {
      color: #333 !important;
    }
    span,
    i {
      color: #999 !important;
    }
  }
}
</style>
